module.exports = __webpack_public_path__ + "img/1.28e56881.png";